import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartSuccessionFieldPack: FieldPack = {
  id: 'orgchart-succession',
  name: 'Succession Planning',
  description: 'Key position flags, pipeline depth, and development plans for succession workshops',
  version: '1.0.0',
  dependencies: ['orgchart-base', 'orgchart-talent'],
  fields: [
    {
      id: 'keyPosition',
      label: 'Key Position',
      type: FieldType.BOOLEAN,
      tags: ['succession'],
      priority: 90,
      namespace: 'succession',
      sensitivity: 'hr_restricted',
      // Canonical ownership is the Position fact. Keep this compatibility
      // declaration for field discovery without changing its policy identity.
      fieldPackId: 'orgchart-position',
      sourceTypes: ['position_structure'],
    },
    {
      id: 'successorCount',
      label: 'Named Successors',
      type: FieldType.NUMBER,
      tags: ['succession'],
      priority: 85,
      namespace: 'succession',
      min: 0,
      readonly: true,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'readyNowSuccessor',
      label: 'Ready Now Successor',
      type: FieldType.TEXT,
      tags: ['succession'],
      priority: 80,
      namespace: 'succession',
      readonly: true,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'successionRisk',
      label: 'Succession Risk',
      type: FieldType.SELECT,
      tags: ['succession'],
      priority: 75,
      namespace: 'succession',
      options: [
        { value: 'critical', label: 'Critical - No Successor' },
        { value: 'high', label: 'High - Weak Pipeline' },
        { value: 'medium', label: 'Medium - Developing Pipeline' },
        { value: 'low', label: 'Low - Strong Pipeline' },
      ],
      readonly: true,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'benchStrength',
      label: 'Bench Strength',
      type: FieldType.SELECT,
      tags: ['succession'],
      priority: 70,
      namespace: 'succession',
      options: [
        { value: 'strong', label: 'Strong' },
        { value: 'adequate', label: 'Adequate' },
        { value: 'weak', label: 'Weak' },
        { value: 'none', label: 'None' },
      ],
      readonly: true,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'developmentPlan',
      label: 'Development Plan',
      type: FieldType.TEXT,
      tags: ['succession', 'development'],
      priority: 65,
      namespace: 'succession',
      multiline: true,
      readonly: true,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'mentor',
      label: 'Mentor',
      type: FieldType.TEXT,
      tags: ['succession', 'development'],
      priority: 60,
      namespace: 'succession',
      sensitivity: 'hr_restricted',
    },
    {
      id: 'coach',
      label: 'Coach',
      type: FieldType.TEXT,
      tags: ['succession', 'development'],
      priority: 55,
      namespace: 'succession',
      sensitivity: 'hr_restricted',
    },
    {
      id: 'careerPath',
      label: 'Career Path',
      type: FieldType.TEXT,
      tags: ['succession', 'career'],
      priority: 50,
      namespace: 'succession',
      sensitivity: 'hr_restricted',
    },
    {
      id: 'yearsToReadiness',
      label: 'Years to Readiness',
      type: FieldType.NUMBER,
      tags: ['succession'],
      priority: 45,
      namespace: 'succession',
      min: 0,
      max: 10,
      step: 0.5,
      readonly: true,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'criticalExperience',
      label: 'Critical Experience Gaps',
      type: FieldType.TEXT,
      tags: ['succession', 'development'],
      priority: 40,
      namespace: 'succession',
      multiline: true,
      readonly: true,
      sensitivity: 'hr_restricted',
    },
    {
      id: 'retentionStrategy',
      label: 'Retention Strategy',
      type: FieldType.TEXT,
      tags: ['succession', 'retention'],
      priority: 35,
      namespace: 'succession',
      multiline: true,
      sensitivity: 'hr_restricted',
    },
  ],
};
